(() => {
  const OVERLAY_SELECTOR = '.background-overlay, .background-overlay1';
  const VERTICAL_MENU_SELECTOR = '.header-nav-vertical-menu .vertical-menu:not(.vertical-menu__style_3)';
  const VERTICAL_MENU_TOGGLE_SELECTOR = '.header-nav-vertical-menu .vertical-menu .categories-title__button';
  const VERTICAL_MENU_INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'summary',
    '[role="button"]',
    '[data-toggle-menu-mb]',
  ].join(',');
  const ARRIVALS_CONTROL_SELECTOR = '[data-arrivals-tab], [data-arrivals-prev], [data-arrivals-next]';
  const PRODUCT_CARD_SELECTOR = '.product-item, .card-product, .grid-view-item, .product-card, .khf-product';
  const PRODUCT_LINK_SELECTOR = 'a.card-link[href], a.khf-product[href], a[href*="/products/"]';
  const PRODUCT_TAB_CONTROL_SELECTOR = 'product-tab .tab-title, product-tab .toggleLink, product-tab [data-show-more-toogle], product-tab .pdViewTab-close';
  const STYLE_ID = 'kristal-click-guard-style';
  const STALE_STATE_GRACE_MS = 700;

  const overlayStates = [
    { className: 'cart-sidebar-show', overlay: 'main', selectors: ['#halo-cart-sidebar'] },
    { className: 'auth-sidebar-show', overlay: 'main', selectors: ['#halo-auth-sidebar'] },
    { className: 'open_search_mobile', overlay: 'main', selectors: ['#search-form-mobile', '.halo-sidebar_search'], maxWidth: 1024 },
    { className: 'open_search_desktop', overlay: 'main', selectors: ['.halo-search-popup', '.search_details[open]'] },
    { className: 'menu_open', overlay: 'main', selectors: ['#navigation-mobile', '.halo-sidebar_menu'], maxWidth: 1024 },
    { className: 'menu-open', overlay: 'main', selectors: ['.halo-sidebar-menu', '.halo-sidebar_menu'], maxWidth: 1024 },
    { className: 'quick-view-show', overlay: 'main', selectors: ['.halo-quick-view-popup'] },
    { className: 'quickshop-popup-show', overlay: 'main', selectors: ['#halo-quickshop-popup-option-3', '.halo-quick-bulk-popup', '.product-item.quickshop-popup-show .variants-popup'] },
    { className: 'quick_shop_popup_mobile', overlay: 'main', selectors: ['#halo-card-mobile-popup.show'], maxWidth: 767 },
    { className: 'quickshop-list-view-show', overlay: 'main', selectors: ['.halo-product-list-view-popup'] },
    { className: 'show-mobile-options', overlay: 'main', selectors: ['.productView-stickyCart.style-1', '.sticky-product-mobile'], maxWidth: 767 },
    { className: 'size-chart-show', overlay: 'main', selectors: ['.halo-size-chart-popup.is-show', '[data-size-chart-popup]'] },
    { className: 'tab-popup-show', overlay: 'main', selectors: ['product-tab .toggle-content.is-show', '.popup-mobile.is-show', '.sidebar-mobile.is-show'] },
    { className: 'toolbar-modal-open', overlay: 'main', selectors: ['.halo-toolbar-modal', '.halo-toolbar-mobile'], maxWidth: 1024 },
    { className: 'show_popup_notification', overlay: 'main', selectors: ['#notification-popup'] },
    { className: 'has-warning', overlay: 'main', selectors: ['.halo-warning-popup', '[data-warning-popup]'] },
    { className: 'term-condition-show', overlay: 'main', selectors: ['.halo-term-condition-popup', '[data-term-condition-popup]'] },
    { className: 'notify-me-show', overlay: 'main', selectors: ['.halo-notify-popup', '[data-notify-popup]'] },
    { className: 'video-show', overlay: 'main', selectors: ['.halo-video-popup', '[data-popup-video]'] },
    { className: 'is-custom-information', overlay: 'main', selectors: ['#halo-product-custom-information'] },
    { className: 'add-to-cart-show', overlay: 'main', selectors: ['.halo-add-to-cart-popup'] },
    { className: 'cart-upsell-show', overlay: 'main', selectors: ['.halo-upsell-popup'] },
    { className: 'age-verification-show', overlay: 'main', selectors: ['.halo-age-verification-popup'] },
    { className: 'age-verification-message-show', overlay: 'main', selectors: ['.halo-age-verification-popup'] },
    { className: 'ask-an-expert-show', overlay: 'main', selectors: ['#halo-ask-an-expert-popup', '[data-ask-an-expert-popup]'] },
    { className: 'compare-color-show', overlay: 'main', selectors: ['.halo-compare-color-popup'] },
    { className: 'compare-product-show', overlay: 'main', selectors: ['.halo-compare-product-popup'] },
    { className: 'newsletter-show', overlay: 'main', selectors: ['.halo-newsletter-popup', '.halo-promotion-popup'] },
    { className: 'newsletter-message-show', overlay: 'main', selectors: ['.halo-newsletter-success-popup', '.newsletter-success-modal'] },
    { className: 'modal-share-open', overlay: 'main', selectors: ['share-modal[open]', '.share-modal[open]', '.modal-share'] },
    { className: 'recently-popup-mb-show', overlay: 'main', selectors: ['.recently-viewed-popup-mb'] },
    { className: 'before-you-leave-show', overlay: 'main', selectors: ['.halo-before-you-leave-popup'] },
    { className: 'open-mobile-sidebar', overlay: 'main', selectors: ['#halo-sidebar.page-sidebar', '.page-sidebar'], maxWidth: 1024 },
    { className: 'overflow-hidden', overlay: 'main', selectors: ['modal-dialog[open]', 'pickup-availability-drawer[open]'], clearStale: false },
    { className: 'show-pickup-availability', overlay: 'main', selectors: ['pickup-availability-drawer[open]'] },
    { className: 'lang-currency-sidebar-show', overlay: 'language', selectors: ['#halo-language-currency-sidebar'] },
  ];

  const classAddedAt = new Map();
  let scheduled = 0;
  let syncing = false;
  let forwardingClick = false;

  const debugEnabled = () => {
    try {
      return window.localStorage?.getItem('kristalClickDebug') === '1';
    } catch (error) {
      return false;
    }
  };

  const debug = (...args) => {
    if (debugEnabled()) console.log('[kristalClickGuard]', ...args);
  };

  const installStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
.background-overlay[data-kristal-overlay-state="closed"],
.background-overlay1[data-kristal-overlay-state="closed"] {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

body:not(.cart-sidebar-show) #halo-cart-sidebar,
body:not(.auth-sidebar-show) #halo-auth-sidebar,
body:not(.open_search_mobile) #search-form-mobile,
body:not(.menu_open) #navigation-mobile,
body:not(.lang-currency-sidebar-show) #halo-language-currency-sidebar,
body:not(.quick-view-show) .halo-quick-view-popup,
body:not(.quickshop-popup-show) #halo-quickshop-popup-option-3,
body:not(.size-chart-show) .halo-size-chart-popup:not(.is-show),
body:not(.ask-an-expert-show) #halo-ask-an-expert-popup,
body:not(.compare-color-show) .halo-compare-color-popup,
body:not(.compare-product-show) .halo-compare-product-popup,
body:not(.newsletter-show) .halo-newsletter-popup,
body:not(.notify-me-show) .halo-notify-popup,
body:not(.video-show) .halo-video-popup,
body:not(.is-custom-information) #halo-product-custom-information {
  pointer-events: none !important;
}
`;
    document.head.appendChild(style);
  };

  const currentClassSet = () => new Set(document.body.className.split(/\s+/).filter(Boolean));

  const refreshClassTimestamps = () => {
    const current = currentClassSet();
    overlayStates.forEach((state) => {
      if (current.has(state.className) && !classAddedAt.has(state.className)) {
        classAddedAt.set(state.className, Date.now());
      }
      if (!current.has(state.className)) {
        classAddedAt.delete(state.className);
      }
    });
  };

  const isVisibleLayer = (element) => {
    if (!element || !element.isConnected) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    const opacity = Number.parseFloat(style.opacity);
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const intersectsViewport = (
      rect.right > 0 &&
      rect.bottom > 0 &&
      rect.left < viewportWidth &&
      rect.top < viewportHeight
    );

    return (
      rect.width > 1 &&
      rect.height > 1 &&
      intersectsViewport &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      (Number.isNaN(opacity) || opacity > 0.02)
    );
  };

  const hasVisibleLayer = (selectors) => selectors.some((selector) => {
    try {
      return Array.from(document.querySelectorAll(selector)).some(isVisibleLayer);
    } catch (error) {
      debug('Invalid selector skipped:', selector, error);
      return false;
    }
  });

  const matchesViewport = (state) => !state.maxWidth || window.innerWidth <= state.maxWidth;

  const removeStaleBodyStates = () => {
    const bodyClasses = currentClassSet();
    const now = Date.now();

    overlayStates.forEach((state) => {
      if (state.clearStale === false || !bodyClasses.has(state.className)) return;
      if (!matchesViewport(state)) {
        document.body.classList.remove(state.className);
        classAddedAt.delete(state.className);
        debug('Removed viewport-stale overlay state:', state.className);
        return;
      }
      const age = now - (classAddedAt.get(state.className) || now);
      if (age < STALE_STATE_GRACE_MS) return;
      if (hasVisibleLayer(state.selectors)) return;

      document.body.classList.remove(state.className);
      classAddedAt.delete(state.className);
      debug('Removed stale overlay state:', state.className);
    });
  };

  const overlayKind = (overlay) => (overlay.matches('.background-overlay1') ? 'language' : 'main');

  const hasOpenStateForOverlay = (overlay) => {
    const kind = overlayKind(overlay);
    const bodyClasses = currentClassSet();

    return overlayStates.some((state) => (
      state.overlay === kind &&
      matchesViewport(state) &&
      bodyClasses.has(state.className) &&
      hasVisibleLayer(state.selectors)
    ));
  };

  const closeOverlay = (overlay) => {
    overlay.dataset.kristalOverlayState = 'closed';
    overlay.style.setProperty('opacity', '0', 'important');
    overlay.style.setProperty('visibility', 'hidden', 'important');
    overlay.style.setProperty('pointer-events', 'none', 'important');
  };

  const releaseOverlay = (overlay) => {
    overlay.dataset.kristalOverlayState = 'open';
    overlay.style.removeProperty('opacity');
    overlay.style.removeProperty('visibility');
    overlay.style.removeProperty('pointer-events');
  };

  const syncOverlayState = () => {
    if (!document.body || syncing) return;
    syncing = true;
    installStyle();
    refreshClassTimestamps();
    removeStaleBodyStates();

    document.querySelectorAll(OVERLAY_SELECTOR).forEach((overlay) => {
      if (hasOpenStateForOverlay(overlay)) {
        releaseOverlay(overlay);
      } else {
        closeOverlay(overlay);
      }
    });

    syncing = false;
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = window.requestAnimationFrame(() => {
      scheduled = 0;
      syncOverlayState();
    });
  };

  const overlayFromPoint = (event) => {
    if (typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return null;
    const hit = document.elementFromPoint(event.clientX, event.clientY);
    return hit?.closest?.(OVERLAY_SELECTOR) || null;
  };

  const eventElement = (event) => (
    event.target instanceof Element ? event.target : event.target?.parentElement || null
  );

  const elementsFromEventPoint = (event) => {
    if (typeof event.clientX !== 'number' || typeof event.clientY !== 'number' || !document.elementsFromPoint) {
      return [];
    }

    return document.elementsFromPoint(event.clientX, event.clientY).filter((element) => element instanceof Element);
  };

  const arrivalsRoot = (element) => element?.closest?.('.khf-new-arrivals') || null;

  const setArrivalsPanel = (root, name) => {
    if (!root || !name) return false;

    const tabs = Array.from(root.querySelectorAll('[data-arrivals-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-arrivals-panel]'));
    if (!panels.some((panel) => panel.dataset.arrivalsPanel === name)) return false;

    tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.arrivalsTab === name));
    panels.forEach((panel) => {
      const isActive = panel.dataset.arrivalsPanel === name;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    return true;
  };

  const moveArrivalsPanel = (root, direction) => {
    const tabs = Array.from(root.querySelectorAll('[data-arrivals-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-arrivals-panel]'));
    const names = panels.map((panel) => panel.dataset.arrivalsPanel);
    if (!names.length) return false;

    const active = tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.arrivalsTab || names[0];
    const currentIndex = Math.max(0, names.indexOf(active));
    const nextIndex = (currentIndex + direction + names.length) % names.length;
    return setArrivalsPanel(root, names[nextIndex]);
  };

  const controlFromClickStack = (event) => {
    const target = eventElement(event);
    const direct = target?.closest?.(ARRIVALS_CONTROL_SELECTOR);
    if (direct) return direct;

    return elementsFromEventPoint(event).find((element) => element.matches(ARRIVALS_CONTROL_SELECTOR)) || null;
  };

  const handleArrivalsControlClick = (event) => {
    const control = controlFromClickStack(event);
    if (!control) return false;

    const root = arrivalsRoot(control);
    if (!root) return false;

    let handled = false;
    if (control.matches('[data-arrivals-tab]')) {
      handled = setArrivalsPanel(root, control.dataset.arrivalsTab);
    } else if (control.matches('[data-arrivals-prev]')) {
      handled = moveArrivalsPanel(root, -1);
    } else if (control.matches('[data-arrivals-next]')) {
      handled = moveArrivalsPanel(root, 1);
    }

    if (!handled) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    debug('Handled arrivals control click', { control, path: event.composedPath?.() });
    return true;
  };

  const pointInsideRect = (event, rect, pad = 0) => (
    event.clientX >= rect.left - pad &&
    event.clientX <= rect.right + pad &&
    event.clientY >= rect.top - pad &&
    event.clientY <= rect.bottom + pad
  );

  const unionRects = (rects) => rects.reduce((union, rect) => {
    if (!union) return {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height,
    };

    const top = Math.min(union.top, rect.top);
    const right = Math.max(union.right, rect.right);
    const bottom = Math.max(union.bottom, rect.bottom);
    const left = Math.min(union.left, rect.left);

    return {
      top,
      right,
      bottom,
      left,
      width: right - left,
      height: bottom - top,
    };
  }, null);

  const visibleChildRects = (card) => {
    const children = card.matches('.khf-product')
      ? Array.from(card.children)
      : Array.from(card.querySelectorAll(
        '.card-media, .card-information, .card-product__group, .card-action, .khf-product__media, .khf-product__body',
      ));

    return children
      .filter(isVisibleLayer)
      .map((element) => element.getBoundingClientRect())
      .filter((rect) => rect.width > 1 && rect.height > 1);
  };

  const cardVisualRect = (card) => unionRects(visibleChildRects(card)) || card.getBoundingClientRect();

  const blockEscapedProductLink = (event) => {
    const target = eventElement(event);
    const link = target?.closest?.(PRODUCT_LINK_SELECTOR);
    if (!link) return false;

    const card = link.closest(PRODUCT_CARD_SELECTOR);
    if (!card) return false;

    const linkRect = link.getBoundingClientRect();
    const visualRect = cardVisualRect(card);
    const linkEscapesVisualCard = (
      linkRect.left < visualRect.left - 3 ||
      linkRect.top < visualRect.top - 3 ||
      linkRect.right > visualRect.right + 3 ||
      linkRect.bottom > visualRect.bottom + 3
    );

    if (!linkEscapesVisualCard || pointInsideRect(event, visualRect, 3)) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    debug('Blocked escaped product link click', {
      link,
      card,
      linkRect,
      visualRect,
      path: event.composedPath?.(),
    });
    return true;
  };

  const productTabControlFromClickStack = (event) => {
    const target = eventElement(event);
    const direct = target?.closest?.(PRODUCT_TAB_CONTROL_SELECTOR);
    if (direct) return direct;

    return elementsFromEventPoint(event).find((element) => element.matches(PRODUCT_TAB_CONTROL_SELECTOR)) || null;
  };

  const setProductTabContentVisible = (content, visible) => {
    if (!content) return;
    content.classList.toggle('is-active', Boolean(visible));
    content.style.display = visible ? 'block' : 'none';
  };

  const productTabElementById = (root, id) => {
    if (!id) return null;
    const escaped = window.CSS?.escape ? window.CSS.escape(id) : id.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
    return root.querySelector(`#${escaped}`) || document.getElementById(id);
  };

  const handleProductTabTitle = (root, control) => {
    const href = control.getAttribute('href') || '';
    const id = href.replace('#', '');
    if (!id) return false;

    const tabs = Array.from(root.querySelectorAll('.tab-title'));
    const contents = Array.from(root.querySelectorAll('.tab-content'));
    const tabContents = root.querySelector('.tabs-contents');
    const productSection = root.closest('[id^="ProductSection-"], .productView') || document;

    tabs.forEach((tab) => tab.classList.toggle('is-open', tab === control));
    if (tabContents) tabContents.classList.add('is-show');
    productSection.querySelector('.an-horizontal-shaking')?.classList.add('open-tab-content');

    contents.forEach((content) => {
      const isActive = content.id === id;
      const toggleLink = content.querySelector('.toggleLink');
      const toggleContent = content.querySelector('.toggle-content');
      content.classList.toggle('is-active', isActive);
      toggleLink?.classList.toggle('is-open', isActive);
      if (root.classList.contains('layout-horizontal')) {
        setProductTabContentVisible(toggleContent, isActive);
      } else {
        toggleContent?.classList.toggle('is-active', isActive);
      }
    });

    return true;
  };

  const handleProductTabToggle = (root, control) => {
    const content = control.parentNode?.nextElementSibling;
    if (!content) return false;

    const willOpen = !control.classList.contains('is-open');
    control.classList.toggle('is-open', willOpen);

    if ((root.dataset.vertical === 'sidebar' && window.innerWidth > 550) || (control.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
      content.classList.toggle('is-show', willOpen);
      document.body.classList.toggle('tab-popup-show', willOpen);
      document.body.classList.toggle('tab-popup-sidebar-show', willOpen);
      return true;
    }

    if (control.classList.contains('popup-mobile') && window.innerWidth <= 551) {
      content.classList.toggle('is-show', willOpen);
      return true;
    }

    setProductTabContentVisible(content, willOpen);
    return true;
  };

  const handleProductTabReadMore = (root, control) => {
    const href = control.getAttribute('href') || '';
    const id = href.replace('#', '');
    const wrapper = control.closest('.tab-showMore');
    const targetContent = productTabElementById(root, id);
    if (!wrapper || !targetContent) return false;

    const willShowLess = !control.classList.contains('is-less');
    const showText = control.dataset.showMoreText || control.textContent;
    const lessText = control.dataset.showLessText || control.textContent;

    wrapper.classList.toggle('is-show', !willShowLess);
    wrapper.classList.toggle('is-less', willShowLess);
    control.classList.toggle('is-show', !willShowLess);
    control.classList.toggle('is-less', willShowLess);
    control.textContent = willShowLess ? lessText : showText;
    targetContent.style.maxHeight = willShowLess ? 'unset' : wrapper.dataset.desMax ? `${wrapper.dataset.desMax}px` : '';
    return true;
  };

  const handleProductTabClose = (root, control) => {
    root.querySelector('.tabs-contents')?.classList.remove('is-show');
    root.querySelectorAll('.tab-title, .toggleLink').forEach((element) => element.classList.remove('is-open'));
    root.querySelectorAll('.tab-content').forEach((element) => element.classList.remove('is-active'));
    root.querySelectorAll('.toggle-content').forEach((element) => {
      element.classList.remove('is-show', 'is-active');
      element.style.display = '';
    });

    control.closest('.toggle-content')?.classList.remove('is-show');
    document.body.classList.remove('tab-popup-show', 'tab-popup-sidebar-show');
    return true;
  };

  const handleProductTabControlClick = (event) => {
    const control = productTabControlFromClickStack(event);
    if (!control) return false;

    const root = control.closest('product-tab');
    if (!root) return false;

    let handled = false;
    if (control.matches('.tab-title')) {
      handled = handleProductTabTitle(root, control);
    } else if (control.matches('.toggleLink')) {
      handled = handleProductTabToggle(root, control);
    } else if (control.matches('[data-show-more-toogle]')) {
      handled = handleProductTabReadMore(root, control);
    } else if (control.matches('.pdViewTab-close')) {
      handled = handleProductTabClose(root, control);
    }

    if (!handled) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    debug('Handled product tab control click', { control, path: event.composedPath?.() });
    return true;
  };

  const forwardClickThroughClosedOverlay = (event, overlay) => {
    if (forwardingClick || typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return false;

    const target = document.elementFromPoint(event.clientX, event.clientY);
    if (!target || target === overlay || target.closest?.(OVERLAY_SELECTOR)) return false;

    forwardingClick = true;
    window.setTimeout(() => {
      try {
        target.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: event.clientX,
          clientY: event.clientY,
          screenX: event.screenX,
          screenY: event.screenY,
          button: event.button,
          buttons: event.buttons,
          altKey: event.altKey,
          ctrlKey: event.ctrlKey,
          metaKey: event.metaKey,
          shiftKey: event.shiftKey,
        }));
      } finally {
        forwardingClick = false;
      }
    }, 0);

    return true;
  };

  const handleClickCapture = (event) => {
    if (forwardingClick) return;
    if (handleArrivalsControlClick(event)) return;
    if (handleProductTabControlClick(event)) return;
    if (blockEscapedProductLink(event)) return;

    const overlay = overlayFromPoint(event);
    if (!overlay) return;

    syncOverlayState();

    if (overlay.dataset.kristalOverlayState === 'closed') {
      const forwarded = forwardClickThroughClosedOverlay(event, overlay);
      debug('Blocked stale overlay click', {
        target: event.target,
        elementFromPoint: overlay,
        forwarded,
        path: event.composedPath?.(),
      });
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  const closeVerticalMenu = (menu) => {
    menu.classList.add('vertical-menu__hide');
    menu.classList.remove('vertical-menu__open');
  };

  const isVerticalMenuOpen = (menu) => (
    menu.classList.contains('vertical-menu__open') &&
    !menu.classList.contains('vertical-menu__hide')
  );

  const shouldDismissVerticalMenu = (event, menu) => {
    const target = event.target;
    if (!(target instanceof Element)) return false;
    if (target.closest(VERTICAL_MENU_TOGGLE_SELECTOR)) return false;
    if (!menu.contains(target)) return true;
    if (target.closest(VERTICAL_MENU_INTERACTIVE_SELECTOR)) return false;

    return Boolean(target.closest(
      '.header__menu-vertical, .menu-dropdown, .list-menu, .list-menu--disclosure, .site-nav-list-dropdown, .bg_white',
    ));
  };

  const handleVerticalMenuDismiss = (event) => {
    document.querySelectorAll(VERTICAL_MENU_SELECTOR).forEach((menu) => {
      if (!isVerticalMenuOpen(menu)) return;
      if (shouldDismissVerticalMenu(event, menu)) closeVerticalMenu(menu);
    });
  };

  const handleVerticalMenuKeydown = (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(VERTICAL_MENU_SELECTOR).forEach((menu) => {
      if (isVerticalMenuOpen(menu)) closeVerticalMenu(menu);
    });
  };

  const inspectPoint = (x, y) => {
    const element = document.elementFromPoint(x, y);
    return {
      element,
      overlay: element?.closest?.(OVERLAY_SELECTOR) || null,
      bodyClasses: document.body.className,
    };
  };

  const init = () => {
    if (!document.body) return;

    syncOverlayState();
    [120, 700, 1400].forEach((delay) => window.setTimeout(syncOverlayState, delay));

    document.addEventListener('click', handleClickCapture, true);
    document.addEventListener('pointerdown', handleVerticalMenuDismiss, true);
    document.addEventListener('keydown', handleVerticalMenuKeydown);
    window.addEventListener('pageshow', scheduleSync);
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('orientationchange', scheduleSync);
    document.addEventListener('shopify:section:load', scheduleSync);
    document.addEventListener('shopify:section:select', scheduleSync);

    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    window.kristalClickGuard = {
      sync: syncOverlayState,
      inspectPoint,
      states: () => overlayStates.map((state) => ({
        className: state.className,
        active: document.body.classList.contains(state.className),
        visibleLayer: hasVisibleLayer(state.selectors),
      })),
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
